import React from 'react';
import { GlobalStyles } from '@mui/material';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import { Router } from './Router';
import { Toaster } from './features/Toaster';
import { AuthProvider } from './AuthProvider';
import { IntercomProvider } from './providers';

const theme = createTheme({
  components: {
    MuiInputBase: {
      defaultProps: {
        disableInjectingGlobalStyles: true,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          width: '100%',
          margin: '0 !important',
          boxShadow: 'none',
          '&:before': { display: 'none' },
          '& .MuiAccordionSummary-content': {
            margin: '0',
          },
        },
      },
      defaultProps: {
        disableGutters: true,
      },
    },
  },
  palette: {
    primary: {
      main: '#2aafbb',
      contrastText: '#fff',
    },
    secondary: {
      main: '#EB8382',
      contrastText: '#fff',
    },
    text: {
      primary: '#303F56',
    },
    gold: {
      main: '#D4AF37',
    },
  },
});

const App = () => (
  <StyledEngineProvider injectFirst>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider theme={theme}>
        <GlobalStyles
          styles={{
            '@keyframes mui-auto-fill': { from: { display: 'block' } },
            '@keyframes mui-auto-fill-cancel': { from: { display: 'block' } },
          }}
        />
        <AuthProvider>
          <IntercomProvider>
            <NuqsAdapter>
              <Router />
              <Toaster />
            </NuqsAdapter>
          </IntercomProvider>
        </AuthProvider>
      </ThemeProvider>
    </LocalizationProvider>
  </StyledEngineProvider>
);

export default App;
